import type { PerformanceScanResultItemModel } from '@newfold/huapi-js/src/index.schemas';

const MS_PER_DAY = 86_400_000;

/** ~Weekly samples so the chart covers a full year without huge payloads */
const YEAR_SPAN_SCAN_COUNT = 52;

/**
 * Dev mock handler: synthetic Lighthouse scan rows for local UI work.
 * Dates span ~365 days; performance, best practices, accessibility, and SEO
 * scores vary independently (~2–99 when shown as percentages; API uses 0–1).
 */
export const sitePerformanceScansMockHandler = {
  createYearSpanningMockScans(): PerformanceScanResultItemModel[] {
    const now = Date.now();
    const scans: PerformanceScanResultItemModel[] = [];

    for (let i = 0; i < YEAR_SPAN_SCAN_COUNT; i++) {
      const daysAgo =
        (365 * (YEAR_SPAN_SCAN_COUNT - 1 - i)) / (YEAR_SPAN_SCAN_COUNT - 1);
      const created = new Date(now - daysAgo * MS_PER_DAY);
      const iso = created.toISOString();

      const t = i / (YEAR_SPAN_SCAN_COUNT - 1);
      const phase = t * Math.PI * 2;

      /** Map a trig wave into ~0.02–0.99 so UI shows ~2–99 across the year (API = 0–1). */
      const span01 = (wave: number) =>
        Math.min(0.99, Math.max(0.02, 0.015 + 0.975 * wave));

      const performance_score = span01(0.5 + 0.5 * Math.sin(phase));
      const best_practices_score = span01(
        0.5 + 0.5 * Math.sin(phase * 1.37 + 0.8),
      );
      const accessibility_score = span01(
        0.5 + 0.5 * Math.cos(phase * 0.91 + 1.4),
      );
      const seo_score = span01(0.5 + 0.5 * Math.sin(phase * 1.21 - 0.6));

      const overall_score = Math.round((performance_score ?? 0) * 100);
      const fcp = Math.round(280 + 220 * (1 - performance_score));
      const lcp = fcp + Math.round(20 + 40 * Math.abs(Math.sin(phase)));

      scans.push({
        id: 7_700_000 + i,
        accessibility_score,
        best_practices_score,
        performance_score,
        seo_score,
        first_contentful_paint: fcp,
        largest_contentful_paint: lcp,
        cumulative_layout_shift:
          0.0001 + 0.0004 * Math.abs(Math.sin(phase * 2)),
        is_active: null,
        overall_score,
        speed_index: Math.round(1200 + 2800 * (1 - performance_score * 0.85)),
        last_scan_time: null,
        created_at: iso,
        updated_at: iso,
        job_id: `019d760c-12b2-70bf-${String(i).padStart(4, '0')}-e3e2a86b912d`,
        total_blocking_time: Math.round(35 * Math.abs(Math.sin(phase))),
        time_to_first_byte: Math.round(180 + 120 * (1 - performance_score)),
      });
    }

    return scans;
  },
};
